import { render } from "./PreetiToUnicode.vue?vue&type=template&id=3ec5f871&scoped=true"
import script from "./PreetiToUnicode.vue?vue&type=script&lang=js"
export * from "./PreetiToUnicode.vue?vue&type=script&lang=js"

import "./PreetiToUnicode.vue?vue&type=style&index=0&id=3ec5f871&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ec5f871"

export default script